// extracted by mini-css-extract-plugin
export var cta = "DoubleColCTA-module--cta--2DtmP";
export var dash = "DoubleColCTA-module--dash---ki2W";
export var label = "DoubleColCTA-module--label--PRbWk";
export var orange = "DoubleColCTA-module--orange--pRCWw";
export var section = "DoubleColCTA-module--section--XbmNc";
export var text = "DoubleColCTA-module--text--AXF8h";
export var title = "DoubleColCTA-module--title--dKp7w";
export var wrapper = "DoubleColCTA-module--wrapper--3KPv9";